<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <EditEquipmentForm />
    </PageRowWrapper>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import EditEquipmentForm from '@/components/settings/stock-registers/editEquipment/EditEquipmentForm'
import LoadingPage from '@/components/spinner/LoadingPage'

export default {
  name: 'EditEquipmentEdit',
  components: {
    PageTitle,
    PageRowWrapper,
    EditEquipmentForm,
    LoadingPage
  },
  computed: {
    ...mapState({
      editEquipment: state => state.editequipment.editEquipmentById
    })
  },
  methods: {
    ...mapActions('editequipment', ['fetchById'])
  }
}
</script>